import React, { useEffect, useState, useCallback, useRef } from "react"; 
import {getdevicetagsModified, statusTableApi } from  "../../Restclient/datacollection";
import { useApiHandler } from '../../hooks/useApiHandler';
import { ErrorTypes } from '../../Restclient/axiosConfig';
import { Checkbox, Typography, Tooltip } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TextField from '@mui/material/TextField';
import AssetTagsRetrievalModified from './AssetTagsRetrievalModified';
import { useSelector, useDispatch } from "react-redux";
import { updateplatjson } from "../../store/login_data";
import { getplantview } from "../../Restclient/datacollection";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CustomTableHeading from "../CommonComponents/CustomTableHeading";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CustomMultiSelectwithDefaultOptions from "../CommonComponents/CustomMultiSelectwithDefaultOptions";
import LK_Delete from "../../images/LK_Delete";
import LK_Edit from "../../images/LK_Edit";
import LK_Loading from "../../images/LK_Loading.gif";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import Questionnaire from "./Questionnaire";
import CustomTableMetric from '../CommonComponents/CustomTableMetric';

// Utility to refresh plantview and update redux
function refreshPlantview(dispatch, orgid, projid) {
    getplantview(orgid, projid, (res) => {
        console.log("res in refreshPlantview",res)
        if (res && res.data) {
            dispatch(updateplatjson(res.data));
        }
    });
}

export default function StatusTableDashboards(){
    // Prevent duplicate warning from being re-triggered immediately after closing
    const duplicateWarningBlocked = useRef(false);
    const dispatch = useDispatch();
    const[configDashboards, setConfigDashboards] = useState([]);
    const [loading,setLoading]=useState(1);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const [dashboardName, setDashboardname] = useState('')
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    const[deleteDashboardFailed, setDashboardFailed] = useState(false);
    const[deleteDashboardSuccess, setDashboardSuccess] = useState(false);
    const [selectedTag, setSelectedTag] = useState({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:''});
    const [focusedFieldKey, setFocusedFieldKey] = useState(null);
    const [numberOfTags, setNumberOfTags] = useState(50);
    const [dashboardSavedName, setDashboardSavedName] = useState('');
    const [visibleTags, setVisibleTags] = useState(50);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const scrollContainerRef = useRef(null);
    const [showAliasFlag, setShowAliasFlag] = useState(true);
    const [duplicateTagDialogOpen, setDuplicateTagDialogOpen] = useState(false);
    const [duplicateTagDialogMsg, setDuplicateTagDialogMsg] = useState("");
    
    // API Handler with dialog control
    const { callApi } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'Resource not found.',
        [ErrorTypes.FORBIDDEN]: 'You do not have permission to access this resource.',
        [ErrorTypes.SERVER_ERROR]: 'Server error occurred. Please try again.'
    });
    
    const[deleteMode, setDeleteMode] = useState(false);
    const [createdSucess, setCreatedSuccess] = useState(false);
    const [notCreatedSuccess, setNotCreatedSuccess] = useState(false);
    const [notCreatedMessage, setNotCreatedMessage] = useState('');
    const[deleteDashboardObject, setDeleteDashboardObject] = useState(false);
    const[editMode, setEditMode] = useState(false);
    const[editDashboardObject, setEditDashboardObject] = useState(false);
    const [updatedSucess, setUpdatedSucess] = useState(false);
    const [notupdatedSucess, setNotUpdatedSucess] = useState(false);
    const [assetdata,setAssetData] = useState(null);
    const [assetdataerror,setAssetDataError] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
    const tagdetailsobject = useSelector((state) => state.mainpagedata.tagdetailsobject);
    const devicedetailsobject = useSelector((state) => state.mainpagedata.devicedetailsobject)
    const themechange = useSelector((state) => state.themedata.theme)
    const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] = useState(false);
    
    const initializeTags = (count) => {
        const tags = [];
        for (let i = 0; i < count; i++) {
            tags[i] = {
                value: '',
                tagid: '',
                tagname: '',
                tagunit: '',
                std_tagname: '',
                tagdatatype: '',
                projectid: '',
                enabled: false,
                aggregation:''
            };
        }
        return tags;
    };
    
    const [dashboardConfig, setDashboardConfig] = useState(() => {
        return {
            dashboardName: '',
            tags: initializeTags(50)
        };
    });

    // UseEffect to handle selected tag application to focused field
        useEffect(() => {
            if (duplicateTagDialogOpen) {
                duplicateWarningBlocked.current = true;
                return;
            }
            // Only allow duplicate warning to be re-triggered after dialog is closed
            if (duplicateWarningBlocked.current && !duplicateTagDialogOpen) {
                duplicateWarningBlocked.current = false;
                return;
            }
            if (focusedFieldKey && selectedTag?.tagname) {
                // Gather all assigned tagids except the current placeholder
            const assignedTagIds = new Set();
            dashboardConfig.tags.forEach((tag, idx) => {
                if (tag.enabled && `tags[${idx}]` !== focusedFieldKey) {
                    assignedTagIds.add(tag.tagid);
                }
            });
            // If selectedTag.tagid is already assigned elsewhere, show warning and ignore
            if (assignedTagIds.has(selectedTag.tagid)) {
                if (!duplicateWarningBlocked.current) {
                    setDuplicateTagDialogMsg(`The tag '${selectedTag.tagname}' is already assigned to another placeholder. Please select a different tag.`);
                    setDuplicateTagDialogOpen(true);
                }
                return;
            }
            // Otherwise, assign as usual
                const updatedConfig = { ...dashboardConfig };
                const keys = focusedFieldKey
                    .replace(/\[(\d+)\]/g, '.$1')
                    .split('.');
                let obj = updatedConfig;
                for (let i = 0; i < keys.length - 1; i++) {
                    const key = isFinite(keys[i]) ? Number(keys[i]) : keys[i];
                    obj = obj[key];
                }
                const finalKey = keys[keys.length - 1];
                if (obj[finalKey]) {
                    obj[finalKey].value = selectedTag.tagname;
                    obj[finalKey].tagid = selectedTag.tagid;
                    obj[finalKey].tagname = selectedTag.tagname;
                    obj[finalKey].tagunit = selectedTag.tagunit;
                    obj[finalKey].std_tagname = selectedTag.std_tagname;
                    obj[finalKey].tagdatatype = selectedTag.tagdatatype;
                    obj[finalKey].projectid = selectedTag.projectid;
                    obj[finalKey].enabled = true;
                    obj[finalKey].aggregation = '';
                }
                setDashboardConfig(updatedConfig);
                setFocusedFieldKey(null);
                setSelectedTag(null);
            }
        }, [selectedTag, focusedFieldKey,dashboardConfig.tags, duplicateTagDialogOpen]);

        // When dialog closes, also clear focusedFieldKey and selectedTag to allow new selection
        const handleCloseDuplicateTagDialog = () => {
            setDuplicateTagDialogOpen(false);
            setFocusedFieldKey(null);
            setSelectedTag(null);
        };

        // Handle focus on tag input fields
        const handleTagFieldFocus = (index) => {
            if (!selectedTag || !selectedTag.tagid) {
                // setDuplicateTagDialogMsg("Please select a tag first before assigning to a placeholder.");
                // setDuplicateTagDialogOpen(true);
                return;
            }
            setFocusedFieldKey(`tags[${index}]`);
            console.log("Focused field:", `tags[${index}]`);
        }

    const assetcallback = (res) => {
        console.log("res obtd in assetscallback in OverviewHomePage",res)
        if(res.success == true){
            setAssetData({devices: res.devices});
        }else{
            setAssetData({devices: {}});
        }
    };

    useEffect(() => {
             getdevicetagsModified(assetcallback)
        }, [selectedprojectname]);

    // Handle tag field value change
    const handleTagFieldChange = (index, value) => {
        if (!selectedTag || !selectedTag.tagid) {
            setDuplicateTagDialogMsg("Please select a tag first before assigning to a placeholder.");
            setDuplicateTagDialogOpen(true);
            return;
        }

        setDashboardConfig(prev => {
            const updated = { ...prev };
            updated.tags[index] = {
                ...updated.tags[index],
                value: value,
                enabled:true
            };
            return updated;
        });
        setSelectedTag(null);
    }

      const handleNumberOfTagsChange = (event) => {
        const newCount = parseInt(event.target.value);
        setNumberOfTags(newCount);
        setVisibleTags(Math.min(50, newCount));
        
        // Update dashboard config with new number of tags
        setDashboardConfig(prev => {
            const currentTags = [...prev.tags];
            const newTags = initializeTags(newCount);
            
            // Preserve existing configured tags
            for (let i = 0; i < Math.min(currentTags.length, newCount); i++) {
                newTags[i] = currentTags[i];
            }
            
            return {
                ...prev,
                tags: newTags
            };
        });
    };

    // Handle aggregation change for a tag
    const handleAggregationChange = (index, aggValue) => {
        setDashboardConfig(prev => {
            const updated = { ...prev };
            updated.tags[index] = {
                ...updated.tags[index],
                aggregation: aggValue
            };
            return updated;
        });
    }

    // Handle tag field clear
    const handleClearTagField = (index) => {
        setDashboardConfig(prev => {
            const updated = { ...prev };
            updated.tags[index] = {
                value: '',
                tagid: '',
                tagname: '',
                tagunit: '',
                std_tagname: '',
                tagdatatype: '',
                projectid: '',
                enabled: false,
                aggregation: ''
            };
            return updated;
        });
    }

    function handledashboardNameChange(value){
        console.log("handledashboardNameChange",value)
        setDashboardname(value)
        // Also update the dashboard config
        setDashboardConfig(prev => ({
            ...prev,
            dashboardName: value
        }));
    }

    const loadMoreTags = useCallback(() => {
        if (isLoadingMore || visibleTags >= numberOfTags) return;
        
        setIsLoadingMore(true);
        setTimeout(() => {
            setVisibleTags(prev => Math.min(prev + 50, numberOfTags));
            setIsLoadingMore(false);
        }, 300);
    }, [isLoadingMore, visibleTags, numberOfTags]);
    
     // Render tag configuration fields
    const renderTagConfigFields = () => {
        // Ensure dashboardConfig.tags has the correct length
        const actualTags = dashboardConfig.tags.length >= numberOfTags 
            ? dashboardConfig.tags 
            : [...dashboardConfig.tags, ...initializeTags(numberOfTags - dashboardConfig.tags.length)];
        
        const visibleTagsArray = actualTags.slice(0, visibleTags);

        return (
            <Box sx={{ marginTop: '20px', maxHeight: '400px', overflowY: 'auto', paddingRight: '32px' }} ref={scrollContainerRef}>
                <div style={{display:'flex', flexDirection:'row',gap:"40px"}}>
                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px"}}>
                        Edit Status Dashboard Configuration: {dashboardSavedName || 'Not set'}
                    </Typography>
                </div>
                <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'baseline', marginBottom: '15px' }}>
                    <Typography sx={{
                        fontSize:"16px",
                        fontFamily: "Roboto",
                        color:'var(--SecondaryText)',fontWeight: 400,
                        marginBottom: "15px"
                    }}>
                        Tag Configuration: Select number of tags to configure
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                        <select
                            value={numberOfTags}
                            onChange={handleNumberOfTagsChange}
                            style={{ 
                                marginLeft: '8px',
                                height: '30px',
                                minWidth: '220px',
                                fontSize: '14px',
                                fontFamily: 'Roboto',
                                fontWeight: '700',
                                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF',
                                backgroundColor: themechange === 'light' ? '#FFFFFF' : '#19191B',
                                border: 'none',
                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`,
                                borderRadius: '0',
                                padding: '0 4px',
                                outline: 'none',
                                cursor: 'pointer',
                                scrollbarWidth: 'thin',
                                scrollbarColor: `#008CD7 ${themechange === 'light' ? '#ffffff' : '#1e1e1e'}`
                            }}
                            onFocus={(e) => {
                                e.target.style.borderBottom = '2px solid #008CD7';
                                e.target.style.color = '#008CD7';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                e.target.style.color = themechange === 'light' ? '#3C3C3C' : '#FFFFFF';
                            }}
                            onMouseEnter={(e) => {
                                if (document.activeElement !== e.target) {
                                    e.target.style.borderBottom = '2px solid #008CD7';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (document.activeElement !== e.target) {
                                    e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                }
                            }}
                        >
                            <option value={50} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>50 Tags</option>
                            <option value={100} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>100 Tags</option>
                            <option value={150} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>150 Tags</option>
                            <option value={200} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>200 Tags</option>
                            <option value={250} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>250 Tags</option>
                            <option value={300} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>300 Tags</option>
                        </select>
                    </FormControl>
                </Box>
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px',width:"1200px"  }}>
                    {visibleTagsArray.map((tag, index) => {
                        // Get unique aggregation options (Function) for this tag
                        let uniqueAggs = [];
                        if (tag.tagid && tagdetailsobject[tag.tagid]?.StorageID) {
                            const seen = new Set();
                            uniqueAggs = tagdetailsobject[tag.tagid].StorageID.filter(agg => {
                                if (!agg.Function || seen.has(agg.Function)) return false;
                                seen.add(agg.Function);
                                return true;
                            });
                        }
                        return (
                        <Box key={index} sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '20px',
                            padding: '10px',
                            width: "320px",
                            border: '1px solid #005C8E',
                            borderRadius: '8px',
                            backgroundColor: 'rgba(0, 92, 142, 0.1)'
                        }}>
                            <Typography sx={{ 
                                minWidth: '60px', 
                                fontSize: '14px',
                                fontWeight:  600,
                                color: '#005C8E'
                            }}>
                                Tag {index + 1}:
                            </Typography>
                            <Tooltip 
                                //title={`${tagdetailsobject[tag.tagid] && tagdetailsobject[tag.tagid].DeviceID && devicedetailsobject[tagdetailsobject[tag.tagid].DeviceID] ? devicedetailsobject[tagdetailsobject[tag.tagid].DeviceID].Name : ""}: ${tag.value}` || "Select tag"} arrow placement="top"
                                 title={(() => {
                                    const tagObj = tagdetailsobject[tag.tagid];
                                    const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                                    const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
                                    const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                                    return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
                                })()}
                                >
                                
                                <TextField
                                    //value={`${tagdetailsobject[tag.tagid] && tagdetailsobject[tag.tagid].DeviceID && devicedetailsobject[tagdetailsobject[tag.tagid].DeviceID] ? devicedetailsobject[tagdetailsobject[tag.tagid].DeviceID].Name : ""}: ${tag.value}`}
                                    value={(() => {
                                        const tagObj = tagdetailsobject[tag.tagid];
                                        const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                                        const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
                                        const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                                        return `${deviceName}: ${showAliasFlag ? alias : name}`;
                                    })()}
                                    placeholder="Select tag"
                                    variant="standard"
                                    size="small"
                                    width="94px"
                                    onFocus={() => handleTagFieldFocus(index)}
                                    onChange={(e) => handleTagFieldChange(index, e.target.value)}
                                    onKeyDown={e => e.preventDefault()}
                                    disabled={!selectedTag || !selectedTag.tagid}
                                    sx={{
                                        flexGrow: 1,
                                        '& .MuiOutlinedInput-root': {
                                            fontSize: '14px',
                                            height: '35px',
                                            color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                        },
                                        '& .MuiOutlinedInput-input::placeholder': {
                                            color: themechange === 'light' ? '#7e7e7e' : '#5b5b5b',
                                            opacity: 1
                                        },
                                         '& .MuiInputBase-input:focus': {
                                                    color: '#008CD7',
                                                },
                                                '& .MuiInputBase-root': {
                                                    fontFamily: 'Roboto',
                                                    fontSize: '16px',
                                                    fontWeight: '700',
                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                },
                                                '& .MuiInput-root .MuiInputBase-input': {
                                                    
                                                },
                                                '& .MuiInputBase-root::before': {
                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                },
                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                    borderBottom: '2px solid #008CD7',
                                                },
                                                '& .MuiInputBase-root::after': {
                                                    borderBottom: '2px solid #008CD7',
                                
                                                },
                                    }}
                                />
                            </Tooltip>
                            {/* Aggregation dropdown for enabled tags with tagid and StorageID */}
                            {tag.tagid && tagdetailsobject[tag.tagid]?.StorageID && (
                                <select
                                    value={tag.aggregation || ''}
                                    onChange={e => handleAggregationChange(index, e.target.value)}
                                    style={{ 
                                        marginLeft: '8px',
                                        height: '30px',
                                        minWidth: '120px',
                                        fontSize: '14px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '700',
                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF',
                                        backgroundColor: themechange === 'light' ? '#FFFFFF' : '#19191B',
                                        border: 'none',
                                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`,
                                        borderRadius: '0',
                                        padding: '0 4px',
                                        outline: 'none',
                                        cursor: 'pointer',
                                        scrollbarWidth: 'thin',
                                        scrollbarColor: `#008CD7 ${themechange === 'light' ? '#ffffff' : '#1e1e1e'}`
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderBottom = '2px solid #008CD7';
                                        e.target.style.color = '#008CD7';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                        e.target.style.color = themechange === 'light' ? '#3C3C3C' : '#FFFFFF';
                                    }}
                                    onMouseEnter={(e) => {
                                        if (document.activeElement !== e.target) {
                                            e.target.style.borderBottom = '2px solid #008CD7';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (document.activeElement !== e.target) {
                                            e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                        }
                                    }}
                                >
                                    <option value="" style={{ 
                                        backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                        color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                        padding: '4px 8px'
                                    }}>Select Aggregation</option>
                                    {uniqueAggs.map((agg, i) => (
                                        <option key={i} value={agg.Function} style={{ 
                                            backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                            color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                            padding: '4px 8px'
                                        }}>
                                            {agg.Function}
                                        </option>
                                    ))}
                                </select>
                            )}
                            {(
                                <Button
                                    size="small"
                                    onClick={() => handleClearTagField(index)}
                                    sx={{
                                        minWidth: '30px',
                                        width: '30px',
                                        height: '30px',
                                        color: '#ff6b6b',
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 107, 107, 0.1)'
                                        }
                                    }}
                                >
                                    ×
                                </Button>
                            )}
                        </Box>
                    )})}
                </Box>
                {visibleTags < numberOfTags && (
                    <Box sx={{ textAlign: 'center', padding: '20px' }}>
                        <Button
                            variant="contained"
                            onClick={loadMoreTags}
                            disabled={isLoadingMore}
                            sx={{
                                backgroundColor: '#005C8E',
                                color: '#FFFFFF',
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontSize: '14px',
                                padding: '8px 24px',
                                '&:hover': {
                                    backgroundColor: '#004A73'
                                },
                                '&:disabled': {
                                    backgroundColor: '#ccc'
                                }
                            }}
                        >
                            {isLoadingMore ? 'Loading...' : `Load More (${visibleTags} / ${numberOfTags} shown)`}
                        </Button>
                    </Box>
                )}
                <Typography sx={{
                    fontSize: "12px",
                    fontFamily: "Roboto",
                    color: 'var(--SecondaryText)',
                    fontWeight: 400,
                    marginTop: "10px",
                    fontStyle: 'italic'
                }}>
                    Configured Tags: {dashboardConfig.tags.filter(tag => tag.tagid).length} / {numberOfTags}
                </Typography>
            </Box>
        );
    }

    function handleDelete(currentDashboard) {
        console.log("handleDelete clicked for dashboard", currentDashboard);
        setDeleteDashboardObject(currentDashboard)
        setDeleteMode(true) 
        // Add your edit logic here 
    }

    function handleDelete(currentDashboard) {
        console.log("handleDelete clicked for dashboard", currentDashboard);
        setDeleteDashboardObject(currentDashboard)
        setDeleteMode(true) 
        // Add your edit logic here 
    }

    async function handleConfirmDialogDeleteDashboard(){
        console.log("handleConfirmDialogDeleteDashboard clicked for dashboard", deleteDashboardObject);
        
        await callApi(
            () => statusTableApi.deleteDashboard(
                deleteDashboardObject?.dashboard_pro,
                deleteDashboardObject?.Projectid,
                deleteDashboardObject?.Organizationid,
                userdetails?.Projectid === "All" ? selectedprojectname : userdetails?.Projectid,
                userdetails?.Organizationid
            ),
            {
                showDialog: false,
                hideDialogOnStatusCodes: [404],
                showDialogOnCatch: false,
                useBackendMessage: true,
                onSuccess: (response) => {
                    console.log("Delete successful:", response);
                    if (response.data.success && response.data?.data && response.data?.data?.data) {
                        setConfigDashboards(response.data?.data?.data);
                        setDashboardSuccess(true);
                        // Refresh plantview after successful delete
                        //refreshPlantview(dispatch, userdetails?.Organizationid, userdetails?.Projectid === "All" ? selectedprojectname : userdetails?.Projectid);
                        getplantview(userdetails?.Organizationid, userdetails?.Projectid === "All" ? selectedprojectname : userdetails?.Projectid, (res) => {
                                console.log("res in refreshPlantview StatusTableDashboard",res)
                                if (res && res.plantview) {
                                    dispatch(updateplatjson(res.plantview));
                                }
                            });
                    } else {
                        setDashboardFailed(true);
                        setNotCreatedMessage(response.data.message || "Failed to delete dashboard.");
                    }
                    setLoading(0);
                },
                onError: (error) => {
                    console.error("Error deleting dashboard:", error);
                    setDashboardFailed(true);
                    setNotCreatedMessage(error?.message || "Failed to delete dashboard. Try Again!");
                    setLoading(0);
                },
                onCatchError: (error, errorInfo) => {
                    console.error("Unexpected error deleting dashboard:", error, errorInfo);
                    setNotCreatedMessage(error?.message || "Unexpected error deleting dashboard.");
                    setDashboardFailed(true);
                    setLoading(0);
                }
            }
        );
        setDeleteMode(false);
    }

    function handleCloseDeleteDashboard(){
        setDeleteMode(false) 
    }

    function handleCloseDeleteDashboardFailed(){
        setDashboardFailed(false) 
    }

    function handleCloseDeleteDashboardSuccess(){
        setDashboardSuccess(false) 
    }

    function handleEdit(currentDashboard){
        let allTags = [];
        console.log("handleEdit clicked for dashboard", currentDashboard);
        var tagprops = currentDashboard.DashboardJSON.widgetlist[0].props.extended.tagprops;
        const totalTags = currentDashboard.DashboardJSON.widgetlist[0].props.extended.numberOfTags;
        setDashboardSavedName(currentDashboard.Dashboardname)
        setNumberOfTags(totalTags);
        setVisibleTags(Math.min(50, totalTags));
        
        for(let i=0;i<tagprops.length;i++){
            let aggregation = '';
            // Try to get aggregation from tagprops[i].taginformationrequired.parameter.calculation.type_of_operation
            if (tagprops[i]?.taginformationrequired?.parameter?.calculation?.type_of_operation) {
                aggregation = tagprops[i].taginformationrequired.parameter.calculation.type_of_operation;
            }
            let object = {
                value: tagdetailsobject[tagprops[i].tagid]?.Alias || '',
                tagid: tagprops[i].tagid,
                tagname: tagdetailsobject[tagprops[i].tagid]?.Alias || '',
                tagunit: tagdetailsobject[tagprops[i].tagid]?.Unit || '',
                std_tagname: tagdetailsobject[tagprops[i].tagid]?.PayloadName || '',
                tagdatatype: tagdetailsobject[tagprops[i].tagid]?.DataType || '',
                projectid: tagdetailsobject[tagprops[i].tagid]?.ProjectID || '',
                enabled: true,
                aggregation: aggregation
            };
            allTags.push(object)
        }
        let remaininglength = totalTags - tagprops.length;
        for(let j=0;j<remaininglength;j++){
            const object = {
                value: '',
                tagid: '',
                tagname: '',
                tagunit: '',
                std_tagname: '',
                tagdatatype: '',
                projectid: '',
                enabled: false,
                aggregation: ''
            };
            allTags.push(object);
        }
        const config = {
            dashboardName: dashboardConfig.dashboardName,
            tags: allTags
        };
        setDashboardConfig(config);
        setEditDashboardObject(currentDashboard);
        setEditMode(true);
    }

    
        function handleCancelUpdatedChange(){
            setEditMode(false)
        }
    
        function handleCloseUpdateDashboard(){
            setUpdatedSucess(false)
        }
    
        function handleCloseNotUpdateDashboard(){
            setNotUpdatedSucess(false)
        }

        function handleCloseNotCreateDashboard(){
            setNotCreatedSuccess(false)
            setNotCreatedMessage('')
        }

        async function handleSaveUpdatedChange(){
            console.log("handleSaveUpdatedChange--dashboardConfig",dashboardConfig,editDashboardObject)
            if(editDashboardObject && editDashboardObject?.dashboard_pro != undefined && editDashboardObject?.dashboard_pro != null){ 
                
                  const configuredTags = dashboardConfig.tags.filter(tag => tag.enabled && tag.tagid);
                    console.log("configuredTags to be sent--Edit",configuredTags)
                    let savedConfiguredTags = [];
                    for(let i=0;i<configuredTags.length;i++){
                        let currentTag = { ...configuredTags[i], tagname:devicedetailsobject[tagdetailsobject[configuredTags[i].tagid]?.DeviceID]?.Name + " : "+ tagdetailsobject[configuredTags[i].tagid]?.Alias};
                        savedConfiguredTags.push(currentTag);
                    }

                    const payload = {
                        dashboardName: editDashboardObject.Dashboardname,
                        DashboardProjectID:editDashboardObject.Projectid,
                        DashboardOrganizationID:editDashboardObject.Organizationid,
                        numberOfTags:numberOfTags,
                        tags: savedConfiguredTags,
                        projectId: userdetails.Projectid === "All" ? selectedprojectname : userdetails.Projectid,
                        organizationId: userdetails.Organizationid,
                        action:"UPDATE",
                        dashboard_pro: editDashboardObject?.dashboard_pro
                    };
                    
                    console.log("payload to be sent--Edit",payload)
                    
                    await callApi(
                        () => statusTableApi.updateDashboard(payload),
                        {
                            showDialog: false,
                            hideDialogOnStatusCodes: [404],
                            showDialogOnCatch: false,
                            useBackendMessage: true,
                            onSuccess: (response) => {
                                console.log("Update successful:", response);
                                if (response.data.success && response.data.data && response.data.data?.data) {
                                    setUpdatedSucess(true);
                                    setConfigDashboards(response.data.data.data);
                                } else {
                                    setNotUpdatedSucess(true);
                                    setNotCreatedMessage(response.data.message || "Failed to update dashboard.");
                                }
                            },
                            onError: (error) => {
                                console.error("Error updating dashboard:", error);
                                setNotCreatedSuccess(true);
                                setNotCreatedMessage(error?.message || "Failed to update dashboard. Try Again!");
                            },
                            onCatchError: (error, errorInfo) => {
                                console.error("Unexpected error updating dashboard:", error, errorInfo);
                                setNotCreatedMessage(error?.message || "Failed to update dashboard due to unexpected error.");
                                setNotUpdatedSucess(true);
                            }
                        }
                    );
            }
        }

    useEffect(() => {
            const fetchDashboards = async () => {
                if(userdetails && selectedprojectname && userdetails.Projectid && userdetails.Organizationid) {
                    await callApi(
                        () => statusTableApi.getDashboards(),
                        {
                            showDialog: false,
                            hideDialogOnStatusCodes: [404],
                            showDialogOnCatch: false,
                            useBackendMessage: true,
                            onSuccess: (response) => {
                                console.log("Dashboards fetched:", response);
                                if (response.data.success && response.data.data && response.data.data?.data) {
                                    setConfigDashboards(response.data.data.data);
                                } else {
                                    setConfigDashboards([]);
                                }
                                setLoading(0);
                            },
                            onError: (error) => {
                                console.error("Error fetching dashboards:", error);
                                setConfigDashboards([]);
                                setLoading(0);
                            },
                            onCatchError: (error, errorInfo) => {
                                console.error(" Unexpected error fetching dashboards:", error, errorInfo);
                                setConfigDashboards([]);
                                setLoading(0);
                            }
                        }
                    );
                }else {
                    console.error("User details are not available or invalid.");
                }
            };
            
            fetchDashboards();
        },[selectedprojectname]);

    return (
        <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"hidden"}}>
            {(editMode == false) && <>
                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Dashboards List</Typography>
                {loading===0 ? (<TableContainer component={Paper} sx={{ width: '100%', maxHeight:"calc(100% - 40px)",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px', overflow:'auto' }} elevation={0}>
                    <Table sx={{ width: '100%' }} size="large" stickyHeader>
                        <TableHead>
                            <TableRow sx={{border:"0px"}}>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Dashboards'} /></TableCell>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5,backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Edit'} /></TableCell>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5,backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Delete'} /></TableCell>
                                {/*<TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5}}><CustomTableHeading children={'Clone'} /></TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {((Array.isArray(configDashboards)) && (configDashboards.length != 0)) ? configDashboards.map((currentDashboard, index) => (
                                <TableRow key={currentDashboard.id}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                        height:"9px",
                                        '& > *': { borderBottom: "1px solid var(--table-boarder-line)" },
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 140, 215, 0.08)',
                                        },
                                        '&:active': {
                                            backgroundColor: 'rgba(0, 140, 215, 0.15)',
                                        }
                                    }}>
                                    {console.log("currentDashboard---///",currentDashboard)}
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><CustomTableMetric children={ currentDashboard.Dashboardname }/></TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleEdit(currentDashboard)} disableTouchRipple elevation={0}><LK_Edit color={"#005C8E"} width={"17px"} height={"17px"}/></Button></TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleDelete(currentDashboard)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"25px"} height={"25px"}/></Button></TableCell>
                                </TableRow>
                            )): <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>No Dashboards Found</Typography>}
                        </TableBody>
                    </Table>
                </TableContainer> )
                :<Box sx={{display:'flex',justifyContent:'center',alignItems:'center',boxSizing:"border-box",height:'calc(100% - 40px)',width:'100%'}} >
                    <img src={LK_Loading} alt="loading..." style={{height:"60px" ,width:"auto"}} />
                </Box>}
            </>}
             {
                (editMode == true) && 
                <>
                    <Box  sx={{padding:"0px",width:"100%" ,boxSizing:"border-box"}} >
                        <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                            <Box sx={{flexGrow:1}}></Box>
                            <CustomButton /*id={assetInfo.id} */ onClick={handleSaveUpdatedChange} buttonText={'Save'} width={'12px'} />
                            <CustomCancelButton  onClick={handleCancelUpdatedChange}  buttonText={'Cancel'}></CustomCancelButton>
                        </Box>
                        
                        <div style={{display:'flex', flexDirection:'row',gap:"40px"}}>
                            <div style={{marginTop:"65px"}}>
                                    {/* Asset Tags Retrieval Component */}
                                <AssetTagsRetrievalModified 
                                    assetdata={assetdata} 
                                    setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} 
                                    setSelectedTag={setSelectedTag} 
                                    setSelectedAsset={setSelectedAsset} 
                                    setShowAliasFlag={setShowAliasFlag} 
                                    selectedTag={selectedTag}
                                />
                            </div>
                            <div>
                                    {/* Render 50 Tag Configuration Fields */}
                                    {renderTagConfigFields()}
                            </div>
                        </div>
                    </Box>
                </>
            }

            <CustomDialogBox dialogTitle={"Delete Dashboard"} dialogText={"Are you sure you want to delete "}  openDialog={deleteMode}  handleCloseDialog={handleCloseDeleteDashboard}  handleConfirmDialog={handleConfirmDialogDeleteDashboard}  confirmText={"Yes"}  cancelText={"No"} type={""}/>
            {/* <CustomDialogBox dialogTitle={"Delete Dashboard"} dialogText={"Are you sure you want to delete "}  openDialog={deleteMode}  handleCloseDialog={handleCloseDeleteDashboard}  handleConfirmDialog={handleConfirmDialogDeleteDashboard}  confirmText={"Yes"}  cancelText={"No"} type={""}/> */}
            <CustomDialogBox dialogTitle={"Delete Dashboard Failed"} dialogText={notCreatedMessage ||"Failed to delete dashboard .Try Again! "}  openDialog={deleteDashboardFailed}  handleCloseDialog={handleCloseDeleteDashboardFailed}  handleConfirmDialog={handleCloseDeleteDashboardFailed}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
            <CustomDialogBox dialogTitle={"Delete Dashboard Success"} dialogText={"Dashboard Successfully deleted "}  openDialog={deleteDashboardSuccess}  handleCloseDialog={handleCloseDeleteDashboardSuccess}  handleConfirmDialog={handleCloseDeleteDashboardSuccess}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
            <CustomDialogBox dialogTitle={"Updated Dashboard Successfully"} dialogText={"Dashboard Successfully updated "}  openDialog={updatedSucess}  handleCloseDialog={handleCloseUpdateDashboard}  handleConfirmDialog={handleCloseUpdateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
            <CustomDialogBox dialogTitle={"Updated Dashboard Failed"} dialogText={"Failed to update dashboard .Try Again! "}  openDialog={notupdatedSucess}  handleCloseDialog={handleCloseNotUpdateDashboard}  handleConfirmDialog={handleCloseNotUpdateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
            <CustomDialogBox dialogTitle={"Operation Failed"} dialogText={notCreatedMessage || "Operation failed. Try Again!"}  openDialog={notCreatedSuccess}  handleCloseDialog={handleCloseNotCreateDashboard}  handleConfirmDialog={handleCloseNotCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
            <CustomDialogBox
                                        dialogTitle={"Duplicate Tag Assignment"}
                                        dialogText={'You cannot assign the same tag to multiple placeholders. Please select a different tag.'}
                                        openDialog={duplicateTagDialogOpen}
                                        handleCloseDialog={handleCloseDuplicateTagDialog}
                                        handleConfirmDialog={handleCloseDuplicateTagDialog}
                                        confirmText={"OK"}
                                        type={"Error"}
                                    />
        </Box>
             
    )
}